function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.367 18.102L18 14H16.5L17.333 18H2.66703L3.50003 14H2.00003L0.632035 18.102C0.285035 19.146 0.900035 20 2.00003 20H18C19.1 20 19.715 19.146 19.367 18.102ZM15 5C15 3.67392 14.4733 2.40215 13.5356 1.46447C12.5979 0.526784 11.3261 0 10 0C8.67395 0 7.40218 0.526784 6.4645 1.46447C5.52682 2.40215 5.00003 3.67392 5.00003 5C5.00003 9.775 10 15 10 15C10 15 15 9.775 15 5ZM7.30003 5.06C7.30003 3.569 8.50804 2.361 10 2.361C10.716 2.361 11.4026 2.64541 11.9089 3.15167C12.4151 3.65792 12.6995 4.34455 12.6995 5.0605C12.6995 5.77645 12.4151 6.46308 11.9089 6.96933C11.4026 7.47559 10.716 7.76 10 7.76C9.28395 7.76 8.59719 7.47554 8.09085 6.96919C7.5845 6.46284 7.30003 5.77608 7.30003 5.06Z",
  fill: "currentColor"
});

function SvgLocationPref(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    color: "#0A8780",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPref);
export default __webpack_public_path__ + "static/media/locationPref.73e57130.svg";
export { ForwardRef as ReactComponent };